type ModalSetter = (open: boolean) => void

const registry = new Map<string, ModalSetter>()

export function registerModal(id: string, setter: ModalSetter) {
	registry.set(id, setter)
}

/**
 * With `setter` given, the id is only dropped while it still points at that
 * setter. A remount (Vite HMR reloads the component) mounts the new instance
 * — which registers — before the old one's `onUnmounted` runs; without the
 * check the old instance would wipe the fresh registration and every `open()`
 * would fail with "no modal registered" until a page reload.
 */
export function unregisterModal(id: string, setter?: ModalSetter) {
	if (setter && registry.get(id) !== setter) return
	registry.delete(id)
}

export function openModal(id: string) {
	const setter = registry.get(id)
	if (setter) setter(true)
	else if (import.meta.env.DEV) console.warn(`[modals] open: no modal registered with id "${id}"`)
}

export function closeModal(id: string) {
	const setter = registry.get(id)
	if (setter) setter(false)
}

export function closeAllModals() {
	registry.forEach((setter) => setter(false))
}

export const useVfm = () => ({
	open: openModal,
	close: closeModal,
	closeAll: closeAllModals,
})
